import { Select, Typography } from 'antd';
import { useAppContext } from 'context/appContext';
import useGetIssuers from 'hooks/useGetIssuers';
import useToastContext from 'hooks/useToastContext';

import React from 'react';
import { IIssuer, IIssuers } from '../../../interfaces/issuers';

const SettingsIssuers = () => {
  const { issuers, isLoading } = useGetIssuers();
  const {
    settings: { issuer, setIssuer },
  } = useAppContext();
  const toast = useToastContext();
  const handleIssuerChange = (issuerChange: string) => {
    const newIssuer = issuers.find(
      iss => iss?.name?.toLowerCase()?.trim() === issuerChange?.toLowerCase()?.trim()
    );
    setIssuer(newIssuer);
    toast.success('Exito!', `Se cambio al issuer ${issuerChange} con exito!`);
  };

  return (
    <>
      <Typography.Title level={2}>Issuer</Typography.Title>

      <Select
        style={{ minWidth: '150px' }}
        loading={isLoading}
        defaultValue={issuer?.name}
        onChange={handleIssuerChange}
        options={issuers?.map((issuer) => ({
          label: issuer?.name,
          value: issuer?.name,
        }))}
      />
    </>
  );
};

export default SettingsIssuers;
